export default __webpack_public_path__ + "static/media/about04.fa7b3a72.png";